import { colors } from 'bold-ui'
import { ColorScale } from 'bold-ui/lib/styles/colors'

import {
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
} from './consulta-seguimento/model-consultaSeguimento'
import { MChatFieldModel, MChatViewModel } from './mchat/model-mchat'

export interface MChatRfFieldModel {
  mchat: MChatFieldModel
  consultaSeguimento: ConsultaSeguimentoFieldModel
}

export interface MChatRfViewModel {
  mchat: MChatViewModel
  consultaSeguimento: ConsultaSeguimentoViewModel
}

export enum MChatRfAccordionSectionEnum {
  MCHAT = 'MCHAT',
  CONSULTA_SEGUIMENTO = 'CONSULTA_SEGUIMENTO',
}

export type MChatRfResultadoType = 'success' | 'warning' | 'error'

export const MCHAT_RF_ACCORDION_SECTIONS = (
  M_CHAT_RF_ENABLED: boolean
): Record<MChatRfAccordionSectionEnum, { title: string; description: string }> => ({
  MCHAT: {
    title: 'M-CHAT-R™',
    description: 'Aplicação a partir dos 16 meses até 30 meses.',
  },
  CONSULTA_SEGUIMENTO: {
    title: 'Entrevista de seguimento',
    description: `A entrevista de seguimento é recomendada para resultados dentro do Risco Médio no M-CHAT-R.${
      !M_CHAT_RF_ENABLED ? ' Acesse o documento original para aplicar a avaliação.' : ''
    }`,
  },
})

export const MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE: Record<MChatRfResultadoType, ColorScale> = {
  success: colors.green,
  warning: colors.orange,
  error: colors.red,
}
